import { HomeSidebar } from "./HomeSidebar";
import { fieldServicePrototypes, cmmsPrototypes } from "./prototypes";

interface HomePageProps {
  onOpenFieldService: () => void;
  onOpenCmms: () => void;
}

export function HomePage({ onOpenFieldService, onOpenCmms }: HomePageProps) {
  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <HomeSidebar
        fieldServicePrototypes={fieldServicePrototypes}
        cmmsPrototypes={cmmsPrototypes}
        onOpenFieldService={onOpenFieldService}
        onOpenCmms={onOpenCmms}
      />
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "var(--spacing-2xl)",
          background: "var(--color-bg-primary)",
        }}
      >
        <svg width="101" height="120" viewBox="0 0 101 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M63.7126 3.3888L87.7208 16.6508C95.9362 21.1889 101 29.5947 101 38.6938V81.3062C101 90.4053 95.9362 98.8111 87.7208 103.349L63.7126 116.611C55.533 121.13 45.4671 121.13 37.2874 116.611L13.2792 103.349C5.06384 98.8111 0 90.4053 0 81.3062V38.6938C0 29.5947 5.06384 21.1889 13.2792 16.6508L37.2874 3.3888C45.4671 -1.1296 55.533 -1.1296 63.7126 3.3888ZM37.7673 26.5322L37.5182 26.6685L16.5713 38.2793C8.61938 42.687 3.69036 50.7949 3.59258 59.596L3.5911 59.8629V60.1371C3.5911 68.9519 8.44059 77.1039 16.3312 81.586L16.5713 81.7207L37.5182 93.3315C45.4685 97.7383 55.2449 97.7837 63.2328 93.4678L63.4818 93.3315L84.4287 81.7207C92.3806 77.313 97.3096 69.2051 97.4074 60.404L97.4089 60.1371V59.8629C97.4089 51.0481 92.5594 42.8961 84.6688 38.414L84.4287 38.2793L63.4818 26.6685C55.5315 22.2617 45.7552 22.2163 37.7673 26.5322Z" fill="#E8EAED" />
        </svg>
        <p
          style={{
            maxWidth: 260,
            margin: 0,
            textAlign: "center",
            fontFamily: "var(--font-family-base)",
            fontSize: 18,
            fontWeight: 700,
            color: "var(--color-content-primary)",
          }}
        >
          Click on any of the navigation links and check out that prototype
        </p>
      </div>
    </div>
  );
}
